import React from "react";
import styled from "@emotion/styled";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import InfoIcon from "../../assets/icons/Info-icon.svg";
// import axios from 'axios'
import Api from "../../utils/api";

export const RegisterCode = (props) => {
  const { role = "", setSchool, setRegisterNow } = props;
  const [code, setCode] = React.useState("");

  const getSchoolBySecretCode = async (code) => {
    await Api.get(`schools/checkSecretCode/${code}/${role}`)
      .then((res) => {
        if (res.data.school) {
          setSchool(res.data.school);
          setRegisterNow(true);
        } else {
          alert("ไม่พบข้อมูลโรงเรียนที่ท่านสังกัด");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onHandleJoin = (value) => {
    getSchoolBySecretCode(value);
  };
  return (
    <>
      <InputCodeSect style={role === "student" ? { marginBottom: "64px" } : {}}>
        <span>กรอกรหัสโรงเรียนเพื่อเข้าร่วม</span>
        <Input
          onInput={(e) => setCode(e.target.value)}
          placeholder="โปรดระบุ"
        />
        <JointButton
          active={code}
          disabled={!code}
          onClick={(e) => onHandleJoin(code)}
        >
          เข้าร่วม
        </JointButton>
      </InputCodeSect>
      {role !== "student" && (
        <>
          <NoCode>
            <img src={InfoIcon} />
            <span>สำหรับโรงเรียนที่ยังไม่มี Code เข้าร่วม</span>
          </NoCode>
          <NoCodeButton onClick={() => setRegisterNow(true)}>
            สมัครเพื่อเริ่มสร้าง code
          </NoCodeButton>
        </>
      )}
    </>
  );
};

const NoCodeButton = styled.button`
  width: 230px;
  height: 51px;
  border: 1px solid #16af7b;
  border-radius: 100px;
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 19px;
  letter-spacing: -0.02em;
  margin: auto;
  padding: 0;
  margin-top: 22px;

  /* Primary/Green 400 */

  color: #16af7b;

  background: #b5f6df;
`;

const NoCode = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 46px;
  span {
    font-family: "Noto Sans Thai", "Noto Sans";
    margin: auto;
    line-height: 2px;
  }
`;

const InputCodeSect = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: "Noto Sans Thai";
  padding: 24px;
  height: 207px;
  width: 100%;
  gap: 14px;
  margin-top: 40px;
  justify-content: space-between;

  span {
    font-family: "Noto Sans Thai";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;

    text-align: center;

    color: #4b5768;
  }

  background: #b5f6df;
`;

const JointButton = styled.button`
  border-radius: 100px;
  width: 206px;
  height: 51px;
  border: 0;
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: 19px;
  background-color: ${(props) => (props.active ? "#16AF7B" : "#D0D5DD")};
  color: ${(props) => (props.active ? "#FFFFFF" : "#64748B")};
`;

const Input = styled.input`
  height: 52px;
  width: 60%;
  border: 0;
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  // color: #b8c0cc;

  ::placeholder {
    color: #b8c0cc;
  }
  padding-left: 10px;
  ${responsive.tablet(css``)}

  ${responsive.mobile(css`
    width: 90%;
    height: 44px;
  `)}
`;
